import * as React from "react";
import DashBoardDataService from "../Service/DataService";
import { tileLayoutShimmerEffect } from "../../ReusableComponents";
import { history, successToastr } from "../../../HelperMethods";
import { MANAGE_MY_TASKS } from "../../Shared/ApiUrls";
import DashboardIcons from "../DashboardIcons";
import { ExportExcel, getIconWithColor, toolTip } from "../GlobalActions";
import { TileLayout } from "@progress/kendo-react-layout";
import ActionIcon from "../ActionIcon";
import { toODataString } from "@progress/kendo-data-query";
import { EXCEL_DOWNLOAD_SUCCESS_MSG, TASKS_SAVED_SUCCESS_MSG } from "../../Shared/AppMessages";
import { DashboardHandleAction, EntityType } from "../../Shared/AppConstants";

export interface TasksProps { }
export interface TasksState {
    data?: any;
    windowWidth?: any;
    noOfCards?: any;
    openTaskDetailBox: any;
    taskTypeId?: any;
    firstLoad?: boolean;
    setInterval?: any;
    isReorderable: boolean;
    layoutData: any;
    excelData?: any;
    taskGroup: string;
    position?: any;
    originalPositionData?: any;
    dashboardVitalsUserMapId?: string;
}

class Tasks extends React.Component<TasksProps, TasksState> {
    activeItem;
    tiles: [];
    constructor(props: TasksProps) {
        super(props);
        this.state = {
            data: [],
            windowWidth: window.innerWidth,
            noOfCards: 4,
            openTaskDetailBox: false,
            setInterval: 10000,
            firstLoad: true,
            isReorderable: false,
            layoutData: [],
            taskGroup: "",
        };
    }

    componentDidMount() {
        this.getTasks();
    }

    getTasks = () => {
        DashBoardDataService.getTasks().then((res) => {
            let posData = this.getPositionData(res.data);
            this.setState({
                data: res.data,
                firstLoad: false,
                position: posData,
                originalPositionData: posData,
                dashboardVitalsUserMapId: res.data[0]?.dashboardVitalsUserMapId
            });
        });
    };

    getPositionData = (data) => {
        return data.map((task, i) => {
            let data = {
                order: i + 1,
                taskId: task.taskTypeId,
            }
            return data;
        })
    }

    tileData = ({ name, value, icon, taskGroup, taskTypeId }) => (
        <div className="card mx-0 p-3 card-radius mb-1 shadow-sm" style={{ userSelect: 'none' }}>
            {toolTip(
                <div className="row">
                    <div className="col-12 d-flex align-items-center justify-content-between mb-2">
                        <h3 title={name} className='heading3 d-inline-block d-flex align-items-center justify-content-start mb-0'>
                            {getIconWithColor(icon)}
                            {name}</h3>
                        <span className='largText'>
                            <span title={value}>{value}</span>
                        </span>
                    </div>
                    <div className="col-12 text-rightcol-12 text-right d-flex align-items-center justify-content-end top-space pb-1">
                        {!this.state.isReorderable ?
                            <>
                                <button
                                    className='btn-transp icon-center mr-3 icon-squire'
                                    title="Export"
                                    id={`${taskTypeId}_export`}
                                    onClick={() => this.downloadExcelTileData(taskTypeId, taskGroup)}
                                > <img className='normal-icon' src={DashboardIcons.downloadIcon} />
                                    <img className='hover-icon' src={DashboardIcons.downloadIconHover} />
                                </button>

                                <button
                                    className='btn-transp icon-center icon-squire'
                                    title="View"
                                    id={`${taskTypeId}_view`}
                                    onClick={() => history.push(`${MANAGE_MY_TASKS}/${taskTypeId}/${taskGroup}`)}>
                                    <img className='normal-icon' src={DashboardIcons.rightArrowIcon} />
                                    <img className='hover-icon' src={DashboardIcons.rightArrowIconHover} />
                                </button>
                            </>
                            :
                            <button className='btn-transp icon-center px-2'>

                                <img height={8} width={12} src={DashboardIcons.shuffleIcon} />
                            </button>
                        }
                    </div>
                </div>
            )}
        </div>

    )

    handleClick = async (action?) => {
        const { originalPositionData, isReorderable } = this.state;
        if (action === DashboardHandleAction.SAVE) {
            this.handleSave();
        } else if (action === DashboardHandleAction.CANCEL) {
            this.setState({ position: originalPositionData });
        }
        this.setState({ isReorderable: !isReorderable });
    }

    handleSave = () => {
        const { position, dashboardVitalsUserMapId } = this.state;
        let data = {
            entityType: EntityType.MYTASK,
            recordSequence: JSON.stringify(position)
        };

        if (dashboardVitalsUserMapId == null || dashboardVitalsUserMapId === undefined) {
            DashBoardDataService.postSequence(data).then((res) => {
                successToastr(TASKS_SAVED_SUCCESS_MSG);
                this.setState({ originalPositionData: position });
            });
        } else {
            DashBoardDataService.putSequence(dashboardVitalsUserMapId, data).then((res) => {
                successToastr(TASKS_SAVED_SUCCESS_MSG);
                this.setState({ originalPositionData: position });
            });
        }
    }

    downloadExcelTileData = (taskTypeId, taskGroup, dataState?) => {
        var finalState = {
            ...dataState,
            take: null,
            skip: 0,
        };
        var queryStr = `${toODataString(finalState, { utcDates: true })}`;
        DashBoardDataService.getTasksExcel(taskTypeId, queryStr).then((res: any) => {
            this.setState({
                excelData: res.data,
                taskGroup: taskGroup
            }, () => {
                document.getElementById('taskExcelBtn').click()
                successToastr(EXCEL_DOWNLOAD_SUCCESS_MSG);
            });
        });
    }

    render() {
        const { data, firstLoad, isReorderable } = this.state;
        this.tiles = data && data.length === 0 && !firstLoad ? [] :
            data && data.length && !firstLoad ? data.map((task) => {
                let data = {
                    item: this.tileData(task),
                    resizable: false
                }
                return data;
            })
                : firstLoad && (
                    Array.from({ length: 6 }).map((item, j) => {
                        return tileLayoutShimmerEffect();
                    })
                )

        return (
            <>
                {this.state.excelData && ExportExcel(this.state.excelData, this.state.taskGroup, true)}

                <div className='d-flex align-items-center justify-content-between pt-4 pr-3 my-task-title-wrap'>
                    <h2 className='heading2 mb-0 text-red'>My Tasks</h2>
                    <ActionIcon
                        firstLoad={firstLoad}
                        isReorderable={isReorderable}
                        handleClick={this.handleClick}
                    />
                </div>

                <div className={'col-12 px-0 outo-scroll tile-layout-css pr-2' + (!isReorderable ? ' noEdit' : '')}>


                    {!firstLoad && this.tiles && this.tiles.length === 0 &&
                        <div className="font-weight-bold w-100 mx-auto text-center">No Pending Tasks!</div>
                    }

                    {this.tiles && this.tiles.length > 0 &&
                        <TileLayout
                            columns={1}
                            items={this.tiles}
                            ignoreDrag={() => !isReorderable}
                            positions={this.state.position}
                            onReposition={(e) => this.setState({ position: e.value })}
                        />}
                </div>

            </>
        )
    }
}

export default Tasks;
